export const DEFAULT_PERSON_TYPE = 'FO';
